import type { NodeMock, StatePreset } from "../mock-types";

export const flowStartMock: NodeMock = {
  label: "Flow Start",
  description: "Entry point — passes through instantly",
  state: () => ({}),
  config: {},
};

export const flowStartPresets: StatePreset[] = [];
